import type { PostSurveyInteractiveQuestionRequestBody } from '@genially/contracts';
import { TrackingInteractiveQuestionType } from '@genially/contracts';
import type {
  AnyInteractiveQuestionItemData,
  SurveyInteractiveQuestionDataSnapshotOut,
} from '@genially/document-model';

import { usePlayerClientContext } from '../../PlayerClientProvider/hooks/usePlayerClientContext';
import { IQ } from './IQ';

export const Survey = ({
  question,
}: {
  question: AnyInteractiveQuestionItemData<SurveyInteractiveQuestionDataSnapshotOut>;
}) => {
  const { client } = usePlayerClientContext();

  const handleSubmit = () => {
    const randomAnswer = Math.floor(Math.random() * question.Answers.length);

    const payload: PostSurveyInteractiveQuestionRequestBody = {
      interactiveQuestionId: question.Id,
      timestamp: Date.now(),
      version: 1,
      type: TrackingInteractiveQuestionType.Survey,
      answerIds: [question.Answers[randomAnswer].Id],
      timeTakenToAnswer: 0,
    };

    client.sendInteractiveQuestionAnswer(payload);
  };

  return <IQ question={question} onSubmit={handleSubmit} />;
};
